module.exports = __webpack_public_path__ + "img/line.d899dff4.svg";